
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function PositioningStatement() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section className="py-28 md:py-40 bg-[#fafafa]">
      <div ref={ref} className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className={`text-center mb-20 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-6">
            Our Philosophy
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-[#1d1d1f] leading-[1.1] mb-6">
            Built Like Capital.
            <br />
            <span className="text-[#86868b]">Powered by Intelligence.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative w-full h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/32c43b8d06ab22b783b102149d291f64.jpg"
                alt="Intelligent Infrastructure"
                title="VAZ Global Capital intelligent infrastructure workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className={`transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-2xl md:text-3xl font-serif text-[#1d1d1f] leading-snug mb-6">
              We are not an automation vendor.
              <br />
              <strong>We architect intelligent infrastructure.</strong>
            </p>

            <p className="text-base font-sans font-light text-[#86868b] leading-relaxed mb-10">
              Our systems are designed to replace operational friction with structured visibility, automated precision, and scalable execution — engineered for long-term growth.
            </p>

            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: 'ri-shield-check-line', label: 'Structured Visibility' },
                { icon: 'ri-settings-3-line', label: 'Automated Precision' },
                { icon: 'ri-line-chart-line', label: 'Scalable Execution' },
                { icon: 'ri-funds-line', label: 'Long-Term Growth' },
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white p-5 rounded-xl border border-[#e8e8e8] hover:border-[#D4AF37]/40 transition-all duration-300 group cursor-default"
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-[#D4AF37]/10 rounded-lg mb-3 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                    <i className={`${item.icon} text-[#D4AF37] text-base`}></i>
                  </div>
                  <p className="text-sm font-medium text-[#1d1d1f]">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
